import React from "react";
import { TimestampToDateMoment } from "../../../../utils/timestampToDate";
import { useTranslation } from "react-i18next";
import { Alert } from "@material-ui/lab";
import PageSpinner from "../../../elements/spinner/PageSpinner";

import {
  StyledCol,
  StyledScrollTable,
  StyledTable,
  StyledTableBody,
  StyledTableHead,
  StyledTableRow
} from "../../../styles/styledTable";


const ProjectList = ({ projects }) => {
  const { t } = useTranslation("clientsPage");

  if (!projects) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  if (projects.length === 0) {
    return <Alert severity="warning">{t("details.projects.table.emptyData")}</Alert>;
  }

  return (
    <StyledScrollTable>
      <StyledTable
        width="576"
        size="14"
        className="projects-table"
      >
        <StyledTableHead
          scroll="auto"
          col="3"
          className="projects-table__head"
        >
          <div>
            {t("details.projects.table.name")}
          </div>
          <div className="projects-table__create-date">
            {t("details.projects.table.createDate")}
          </div>
        </StyledTableHead>
        <StyledTableBody>
          {projects && projects.map((value, key) => (
            <StyledTableRow
              key={key}
              scroll="auto"
              col="3"
              className="projects-table__row"
            >
              <StyledCol className="projects-table__project-name">
                {value.name}
              </StyledCol>
              <StyledCol className="projects-table__create-date">
                {TimestampToDateMoment(value.createDate)}
              </StyledCol>
            </StyledTableRow>
          ))}
        </StyledTableBody>
      </StyledTable>
    </StyledScrollTable>
  );
};

export default ProjectList;